import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ApiLoaderComponent } from './core/api-loader/api-loader.component';
import { RouteProgressComponent } from './core/route-progress/route-progress.component';
import { Meta, Title } from '@angular/platform-browser';
import { MessageService } from './services/message.service';
import { LanguageService } from './services/language.service';
import { ErrorDialogBridgeService } from './services/error-dialog-bridge.service';
import { DevtoolsBlockService } from './services/devtools-block.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ApiLoaderComponent, RouteProgressComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'fe-pouch-admin';

  titleService = inject(Title)
  metaService = inject(Meta)
  router = inject(Router)
  messageService = inject(MessageService);
  languageService = inject(LanguageService); // Initialize language service on app start
  private errorDialogs = inject(ErrorDialogBridgeService);
  private devtoolsBlock = inject(DevtoolsBlockService);

  constructor() {
    // Errors show as the error dialog, not as a toast (set up before any page can raise one)
    this.errorDialogs.start();
  }

  async ngOnInit(): Promise<void> {
    // Discourage opening browser DevTools on the deployed portal (off on localhost)
    this.devtoolsBlock.start();

    this.titleService.setTitle('Pouch');
    this.metaService.updateTag({ name: 'description', content: 'The premier ride experience' });

    // Ensure language is loaded from localStorage on app initialization
    // LanguageService constructor already handles this, but we ensure it's initialized
    const currentLang = this.languageService.getCurrentLang();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.hideSplash(), 100);
      }
    });
    // init() starts the message listener and asks for permission; call it once only
    // (calling it twice registered the listener twice)
    const token = await this.messageService.init();
    // console.log('Device token:', token);

    this.messageService.notification$.subscribe(payload => {
      // console.log('Notification received in AppComponent:', payload);
    });
  }

  hideSplash() {
    const splash = document.getElementById('splash-screen');
    if (splash) {
      splash.style.opacity = '0';
      splash.style.transition = 'opacity 0.3s ease';
      setTimeout(() => splash.remove(), 300);
    }
  }

}
